import { Permission } from '../../enums';
import { MenuItem } from '../../interfaces';

export const menuItems: MenuItem[] = [
    {
        title: 'Home',
        icon: 'home',
        link: '/home',
        permissions: [Permission.Home],
    },
    // {
    //     title: 'Location',
    //     icon: 'location',
    //     link: '/location',
    //     permissions: [],
    // },
    {
        title: 'Wallet Transfer',
        icon: 'wallet-money',
        link: 'send-money',
        permissions: [],
    },
];
